<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .mobile-header {
    margin-bottom: 0;
  }
  .approval-overtime {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .col-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .employees-form {
    margin-top: 30px !important;
  }
  .save-info {
    width: 100%;
  }
  .cancel-employee {
    width: 100%;
    margin-top: 5px !important;
  }
  .table {
    width: 550px;
  }
}

.modal-content {
  border: none;

  .warning-title {
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #303c54;
    img {
      margin-right: 10px;
    }
  }
}

.approval-overtime {
  .col-md-10.offset-md-2 {
    margin: auto;
  }

  td.comment {
    max-width: 300px;
    word-wrap: break-word;
  }

  .save-info {
     border-radius: 10px;
    width: 210px;
    height: 40px;
    background-color: #3d4cdc;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-right: 10px;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .cancel-employee {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    background-color: #ececec;
    color: #6f6f6f;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .submit-form {
    margin-top: 30px;
    text-align: center;
  }
}
</style>

<template>
  <CContainer
    class="approval-overtime"
    v-if="employeeOverTimeRequest.requestInfo"
  >
    <div>
      <!-- <div>
        <h2>{{ $t("commons.label_header_approval") }}</h2>
      </div> -->
      <div class="create_form">
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.label_project_name") }}
            </label>
            <CInput
              v-model="employeeOverTimeRequest.requestInfo.project_name"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.label_employee_send") }}
            </label>
            <CInput
              v-model="employeeOverTimeRequest.requestInfo.employee_name"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("overtime.date") }}
            </label>
            <CInput
              v-model="employeeOverTimeRequest.requestInfo.date"
              :disabled="true"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("employee.label_employee_date_start") }}
            </label>
            <CInput
              v-model="employeeOverTimeRequest.requestInfo.start_time"
              :disabled="true"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("overtime.end_time") }}
            </label>
            <CInput
              v-model="employeeOverTimeRequest.requestInfo.end_time"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.status") }}
            </label>
            <CInput
              :value="
                $t(
                  'commons.label_status_' +
                    employeeOverTimeRequest.requestInfo.status
                )
              "
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.label_reason") }}
            </label>
            <b-form-textarea
              id="textarea"
              rows="3"
              max-rows="6"
              v-model="employeeOverTimeRequest.requestInfo.reason"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <!-- Overtime approval list-->
        <CRow class="mt-4">
          <CCol md="12" sm="12" class="employees-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in listEmployeeIdApproval"
                      :key="index"
                    >
                      <th scope="row index">{{ index + 1 }}</th>
                      <td>{{ item.approve_name }}</td>
                      <td>
                        {{
                          $t(
                            `overtime.employee_approval_${item.approve_status}`
                          )
                        }}
                      </td>
                      <td class="comment">{{ item.comment }}</td>
                      <td>{{ item.approved_at | formatDateTime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <div
          v-if="
            myApproveInfo.approve_status === 1 &&
            employeeOverTimeRequest.requestInfo.status === 1
          "
        >
          <ValidationObserver ref="form">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("commons.note") }}
                </label>
                <ValidationProvider
                  rules="max:512"
                  v-slot="{ errors }"
                  name="overtime.note"
                >
                  <b-form-textarea
                    rows="3"
                    max-rows="6"
                    v-model="forms.comment"
                  />
                  <span v-if="!error" class="error image required">
                    {{ errorMessage }}
                  </span>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
              <CCol
                md="12"
                class="employees-form mt-3 text-center"
              >
                <CButton
                  type="button"
                  class="save-info"
                  @click="showApprovalConfirm()"
                >
                  {{ $t("commons.approve") }}
                </CButton>
                <CButton
                  class="cancel-employee"
                  type="button"
                  @click="showRejectConfirm()"
                >
                  {{ $t("commons.cancel_approve") }}
                </CButton>
              </CCol>
              <!-- <CCol v-else md="12" class="employees-form mt-3 text-center">
                <router-link to="/overtime-requests/approval">
                  <CButton class="cancel-employee" type="button">
                    {{ $t("commons.back") }}
                  </CButton>
                </router-link>
              </CCol> -->
            </CRow>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <CusModal
      @handleCancel="hideApprovalConfirm"
      @handleOk="approveRequest"
      :title="$t('popup.overtime.label_popup_confirm_approve_OT_title')"
      :isShow="isShowApprovalConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
    <CusModal
      @handleCancel="hideRejectConfirm"
      @handleOk="cancelRequest"
      :title="$t('popup.overtime.label_popup_confirm_reject_OT_title')"
      :isShow="isShowRejectConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
  </CContainer>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";

export default {
  props: ["id"],
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_approval"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
  },
  computed: {
    ...mapGetters({
      employeeOverTimeRequest: "overtime-request/employeeOverTimeRequest",
      flagNotification: "commons/flagNotification",
    }),
    checkValidDate() {
      let currentSubWeek = moment().subtract(8, "d").format("YYYY-MM-DD");
      return moment(currentSubWeek).isBefore(
        moment(
          this.employeeOverTimeRequest.requestInfo.date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"),
        "day"
      );
    },
  },
  data() {
    return {
      forms: {
        status: 0,
        comment: "",
      },
      error: true,
      errorMessage: "",
      myApproveInfo: {},
      listEmployeeIdApproval: [],
      isShowApprovalConfirm: false,
      isShowRejectConfirm: false,
      searchData: {
        month: moment(),
        status: 0,
        approveStatus: 1,
        itemsPerPage: 10,
        sortColumn: "date",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
    };
  },

  methods: {
    ...mapMutations("commons", ["setNotificationFlag"]),
    ...mapActions("overtime-request", ["listOverTimeRequestApproval"]),

    hideApprovalConfirm() {
      this.isShowApprovalConfirm = false;
    },

    showApprovalConfirm() {
      this.isShowApprovalConfirm = true;
    },

    hideRejectConfirm() {
      this.isShowRejectConfirm = false;
    },

    showRejectConfirm() {
      if (this.forms.comment === "") {
        this.error = false;
        this.errorMessage = this.$t(
          "error.validation.approve_person_comment.required"
        );
        return;
      }
      this.isShowRejectConfirm = true;
    },

    async approveRequest() {
      this.forms.status = 2;
      await this.submitOverTimeRequest();
      this.hideApprovalConfirm();
    },

    cancelRequest() {
      this.forms.status = 3;
      this.submitOverTimeRequest();
      this.hideRejectConfirm();
    },

    async getInfoApproval() {
      if (this.id) {
        this.$root.$loading.start();
        await this.$store.dispatch(
          "overtime-request/showEmployeeOverTimeRequest",
          this.id
        );
        const account = this.$store.getters["auth/account"];
        if (this.employeeOverTimeRequest.approveInfo) {
          this.myApproveInfo = this.employeeOverTimeRequest.approveInfo.filter(
            (f) => f.approve_employee_id === account.id
          )[0];
          this.listEmployeeIdApproval = [];
          let check = 0;
          for (let key in this.employeeOverTimeRequest.approveInfo) {
            if (
              account.id ===
              this.employeeOverTimeRequest.approveInfo[key].approve_employee_id
            ) {
              check++;
              if (check === 2) {
                break;
              }
            }
            this.listEmployeeIdApproval.push(
              this.employeeOverTimeRequest.approveInfo[key]
            );
          }
        }
        this.$root.$loading.finish();
        this.setNotificationFlag(false);
      }
    },

    async getList() {
      this.$root.$loading.start();
      if (this.$route.name === "Overtime Request Approval") {
        if (Object.keys(this.$route.query).length !== 0) {
          let params = this.$route.query;
          this.searchData = {
            month:
              params.month == undefined
                ? moment(this.searchData.month)
                : moment("01/" + params.month, "DD/MM/YYYY"),
            status:
              params.status == undefined
                ? parseInt(this.searchData.status)
                : parseInt(params.status),
            approveStatus:
              params.approveStatus == undefined
                ? parseInt(this.searchData.approveStatus)
                : parseInt(params.approveStatus),
            itemsPerPage: params.perPage,
            sortColumn: params.sortColumn,
            sortBy: params.sortBy,
            paginate: {
              from: params.from,
              to: params.to,
              totalPage: parseInt(params.totalPage),
              path: this.searchData.paginate.path,
              currentPage: parseInt(params.currentPage),
              totalRecord: parseInt(params.totalRecord),
              perPage: parseInt(params.perPage),
            },
          };
        }
        await this.listOverTimeRequestApproval({
          optionPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          month: moment(this.searchData.month).format("MM/YYYY"),
          status: parseInt(this.searchData.status),
          approveStatus: parseInt(this.searchData.approveStatus),
          sortColumn: this.searchData.sortColumn,
          sortBy: this.searchData.sortBy,
        });
      }
      this.$root.$loading.finish();
    },

    async submitOverTimeRequest() {
      if (this.forms.status === 3) {
        if (this.forms.comment === "") {
          this.error = false;
          this.errorMessage = this.$t(
            "error.validation.approve_person_comment.required"
          );
          return false;
        }
      }
      this.$root.$loading.start();
      await this.$store
        .dispatch("overtime-request/approvalOverTime", {
          data: this.forms,
          id: this.id,
        })
        .then(() => {
          let message = this.$t("overtime.message_approval_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.getList();
          this.$emit("ok");
          this.$store.dispatch("commons/getCountRequest");
          this.getInfoApproval();
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    showPopupApprove() {
      this.$confirmModal(
        this.$t("popup.overtime.label_popup_approve_message"),
        this.$t("popup.overtime.label_popup_approve_title"),
        this.$t("popup.overtime.label_popup_title_confirm"),
        this.$t("popup.overtime.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.forms.status = 2;
          this.submitOverTimeRequest();
        }
      });
    },

    showPopupCancel() {
      this.$confirmModal(
        this.$t("popup.overtime.label_popup_reject_message"),
        this.$t("popup.overtime.label_popup_approve_title"),
        this.$t("popup.overtime.label_popup_title_cancel_approve"),
        this.$t("popup.overtime.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.forms.status = 3;
          this.submitOverTimeRequest();
        }
      });
    },
  },

  async created() {
    await this.getInfoApproval();
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        this.listEmployeeIdApproval = [];
        await this.getInfoApproval();
      }
    },
  },
};
</script>
